export default {

    cmpProjHome: {},
    // 0:waiting 1:loading 2:success 3:failed
    cmpProjHomeLoadStatus: 0,

    cmpProjHasChangeForInputBarStatus: 0,

    /** 一覧案件情報更新 **/
    changeCmpProjInfoCommon: {},
    changeCmpProjInfoCommonStatus: 0,

    /** 案件情報情報 **/
    cmpProjInfo: {},
    // create/create_confirm/show/edit/edit_confirm
    cmpProjOperat: "",
    // 0:waiting 1:loading 2:success 3:failed
    saveCmpProjInfoStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    cmpProjInfoLoadStatus: 0,

    // 0:waiting 1:loading 2:success 3:failed
    cmpProjDelStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    cmpProjOffStatus: 0,

    // 公開
    cmpProjPubliced: {},
    cmpProjPublicStatus: 0,
    // 単価公開
    cmpProjPricePubliced: {},
    cmpProjPricePubStatus: 0,

    // 備考
    cmpProjNoted: {},
    cmpProjNoteStatus: 0,

    // 言語分析
    cmpLangGraph: {},
    cmpLangGraphLoadStatus: 0

}
